var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFergusonIsotype = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512",
  width: "1em",
  height: "1em"
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M512 0H384c0 70.7-57.1 127.9-127.8 127.9v127.9C397.6 255.8 512 141.3 512 0zM256.2 383.8v-128C114.9 255.8 0 370.4 0 511.6h128c0-70.6 57.6-127.8 128.2-127.8z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M131.8 286.8c-2.5-9.9-3.8-20.2-3.8-30.9 0-70.8 57.3-128.2 128.1-128.2V1.4C115.1 1.4.9 115.7.9 256.7c0 10.2.6 20.2 1.8 30.1h129.1zm380-30.1c0-11-.7-21.4-2.1-32.1H380.9c2.5 9.9 3.7 20.6 3.7 31.3 0 70.8-57.6 128.2-128.4 128.2V512c141.1 0 255.6-114.3 255.6-255.3z"
})));
export default SvgFergusonIsotype;